# Load View
require('./index.jade')
require('./basic-analysis/basic-analysis.jade')
require('./score-analysis/score-analysis.jade')
require('./stroke-analysis/stroke-analysis.jade')
require('./detailed-analysis/detailed-analysis.jade')
# Load Css
require('../../../sass/web/html/_score_analysis_event.scss')

# Load Components
require('highcharts/highcharts.src')
require('highcharts/highcharts-more.src')
require('angular')
require('angular-route')
require('angular-ui-utils')
require('angular-ui-map')
require('../../core/translation/translation-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/auth/auth-module')
require('../components/analysis-charts/analysis-charts-module')
# require('../components/payment/payment-module')
require('../components/remote-api/remote-api-module')
require('../components/number/number-module')
require("../components/map/map-module")
require("../goal-settings/goal-settings-module.coffee")
require('../components/error-handler/error-handler-module')
require('../components/analyze-access/analyze-access-module')

# Load Dependencies
IndexEventCtrl = require('./index-controller')
BasicAnalysisEventCtrl = require('./basic-analysis/basic-analysis-controller')
AnalysisEventService = require('./analysis-service')
StrokeAnalysisEventCtrl = require('./stroke-analysis/stroke-analysis-controller')
ScoreAnalysisEventCtrl = require('./score-analysis/score-analysis-controller')
DetailedAnalysisEventCtrl = require('./detailed-analysis/detailed-analysis-controller')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-auth'
  'ui.map'
  'gnp-analysis-charts'
  'gnp-app-goal-settings'
  # 'gnp-payment'
  'gnp-remote-api'
  'gnp-error-handler'
  'gnp-number'
  'gnp-map'
  'gnp-analyze-access'
]

angular.module "gnp-app-analysis-event", modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider
    .when '/analysis-event/:id',
      templateUrl: 'web/analysis-event/index.jade'
      controller: 'AnalysisEventCtrl'
      resolve:
        goalSettings: ['GoalAPIService', '$route', (GoalAPIService, $route) ->
          params =
            user_id: $route.current.params.user_id
          GoalAPIService.getGoalSettings(params)
        ]
      title: '_ANALYSIS.TITLE'
      permission:
        signInRequired: false
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
    .translations 'en', require('./i18n/en')
    .translations 'ja', require('./i18n/ja')
  ]
  .controller 'AnalysisEventCtrl', IndexEventCtrl
  .controller 'StrokeAnalysisEventCtrl', StrokeAnalysisEventCtrl
  .controller 'ScoreAnalysisEventCtrl', ScoreAnalysisEventCtrl
  .controller 'BasicAnalysisEventCtrl', BasicAnalysisEventCtrl
  .controller 'DetailedAnalysisEventCtrl', DetailedAnalysisEventCtrl
  .factory "AnalysisEventService", AnalysisEventService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis-event/analysis-module.coffee